import React from 'react';
import { Button } from './ui/button';
import { COSELLER_MIC_COPY } from '../constants/watchSession';

interface CoSellerStatusProps {
  /** `leave_session`, then close every socket and release the mic. Ends nothing for anyone else. */
  onLeave: () => void;
}

/**
 * Shown instead of the owner's controls while the user co-sells someone's
 * desktop call with their own mic: only Leave call (destructive, where the
 * owner's End sits, in the session controls row). The mic is on for the
 * whole call, so there is no mute (owner, 2026-10-07); the header's row 1 ("Live · Co-Seller : {name}") says
 * the user is live. Same as the macOS and WPF apps. A co-seller can only
 * leave (D3): no End, no roster or playbook edits.
 */
const CoSellerStatus: React.FC<CoSellerStatusProps> = ({ onLeave }) => (
  <Button variant="destructive" size="sm" onClick={onLeave}>
    {COSELLER_MIC_COPY.leaveCall}
  </Button>
);

export default CoSellerStatus;
